export enum Role {
  SUPPORT = 'Okta-Backoffice-ACA-Support',
  EDIT = 'Okta-Backoffice-ACA-Edit'
}
